/**
 * A newcomer's name in a line (the revamp): isolated in its own direction, and where there is room, a Persian name's
 * script small after its Finglish (`script`), as the town sheet shows a word.
 */
import { html, nothing } from 'lit';
import { tPart } from '../bidi-html';

export interface NamedPerson { name: string; script?: string; role?: string }

/** The name, Finglish first; with `room`, its script after in a muted isolate. */
export function nameHtml(p: NamedPerson, room = false) {
  return html`<bdi class="nc-name" dir="auto">${p.name}</bdi>${room && p.script ? html` <bdi class="nc-name-script muted" dir="rtl">${p.script}</bdi>` : nothing}`;
}

/** "Jordi, the new neighbour" (`key` fills `{name}` and `{role}`), or just the name without a role. */
export function nameWithRole(key: string, p: NamedPerson, room = true) {
  return p.role ? tPart(key, 'name', nameHtml(p, room), { role: p.role }) : nameHtml(p, room);
}

/** "Answer Jordi": the button's words, the name isolated (no room for the script). */
export function answerLabel(p: NamedPerson, key = 'newcomers.answerNamed') {
  // One child, so a flex button's gap never opens between "Answer" and the name.
  return html`<span class="nc-label">${tPart(key, 'name', nameHtml(p))}</span>`;
}
